import React from 'react';
import { useParams } from 'react-router-dom';

import { Stack, Typography } from '@mui/material';

import {
  useDeleteSavedRouteAlertMutation,
  useGetSavedRouteAlertQuery,
} from 'state/emailAlertsSlices';

import { FloatingLoadingSpinner } from 'features/spinner/Spinner';

import { AlertView } from './AlertView';
import { NotificationsPanel } from './NotificationsPanel';
import { useNotificationProject } from './useNotificationProject';

export function AlertViewPage() {
  const { alertId } = useParams<{ alertId: string }>();

  const { projectSlug, navigateTo } = useNotificationProject();
  const [deleteAlert] = useDeleteSavedRouteAlertMutation();

  const {
    data: alert,
    isLoading,
    error,
  } = useGetSavedRouteAlertQuery(
    { project_slug: projectSlug!, alert_id: alertId! },
    { skip: !projectSlug || !alertId },
  );

  const handleEdit = () => {
    navigateTo.editAlert(alertId!);
  };

  const handleDelete = () => {
    if (!projectSlug) return;
    deleteAlert({
      project_slug: projectSlug,
      alert_id: alertId,
    });
    navigateTo.manage();
  };

  if (!projectSlug || isLoading) {
    return <FloatingLoadingSpinner />;
  }

  if (error || !alert) {
    return (
      <NotificationsPanel>
        <Stack spacing={3}>
          <Typography variant="h4">Alert Not Found</Typography>
        </Stack>
      </NotificationsPanel>
    );
  }

  return (
    <AlertView alert={alert} onEdit={handleEdit} onDelete={handleDelete} />
  );
}
